export default "__VITE_ASSET__9KqcPv3Q__"